import { Ajax } from "../Common/Ajax";
import { GlobalData } from "../Common/GlobalData";
import { ValueSwapHelper } from "../Common/KendoHelpers";

export class WatchListReport {
    private readonly GRID = '#grid';

    private readonly MKT_FIELDS = [
        'mkt_CompositeRating',
        'mkt_CurrentOutlook',
        'mkt_IndustryRankAndRs',
    ];
    private readonly FUND_FIELDS = [
        'fund_EarningsPerShareRating',
        'fund_EarningsStability',
        'fund_ReturnOnEquity',
    ];
    private readonly TECH_FIELDS = [
        'tech_RelativeStrengthRating',
        'tech_AccumDistRating',
        'tech_FullCurrentPctK',
    ];
    private readonly PER_FIELDS = [
        'per_ClosingPrice',
        'per_CostPerShare',
        'per_SumQtyOwn',
    ];

    //MARKET, FUNDAMENTAL, TECHNICAL & PERSONAL
    private readonly NON_MKT_FIELDS = this.FUND_FIELDS.concat(this.TECH_FIELDS)
        .concat(this.PER_FIELDS);
    private readonly NON_FUND_FIELDS = this.MKT_FIELDS.concat(this.TECH_FIELDS)
        .concat(this.PER_FIELDS);
    private readonly NON_TECH_FIELDS = this.MKT_FIELDS.concat(this.FUND_FIELDS)
        .concat(this.PER_FIELDS);
    private readonly NON_PER_FIELDS = this.MKT_FIELDS.concat(this.FUND_FIELDS)
        .concat(this.TECH_FIELDS);

    private gridDataSource: any;

    private static _instance: WatchListReport;
    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        this.init();
    }

    private init() {
        $('[name=valueSwap]').on('change', (event: any) => {
            switch (event.currentTarget.value) {
                case '0':
                    ValueSwapHelper.showHideFields(this.GRID,
                        this.MKT_FIELDS, this.NON_MKT_FIELDS);
                    break;
                case '1':
                    ValueSwapHelper.showHideFields(this.GRID,
                        this.FUND_FIELDS, this.NON_FUND_FIELDS);
                    break;
                case '2':
                    ValueSwapHelper.showHideFields(this.GRID,
                        this.TECH_FIELDS, this.NON_TECH_FIELDS);
                    break;
                case '3':
                    ValueSwapHelper.showHideFields(this.GRID,
                        this.PER_FIELDS, this.NON_PER_FIELDS);
                    break;
            }
        });

        this.gridDataSource = {
            transport: {
                read: GlobalData.URL_BASE + GlobalData.URL_SUFFIX_PERSONAL_REPORTS_WATCH_LIST_REPORT,
            },
        };

        $(this.GRID).kendoGrid({
            dataSource: this.gridDataSource,
            height: 915,
            navigatable: true,
            sortable: true,
            filterable: false,
            pageable: false,
            resizable: true,
            detailInit: this.openDetail,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '7%',
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '22%',
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: left; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: "mkt_CompositeRating",
                    title: "Comp<BR />Rating",
                    width: "7%",
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "mkt_CurrentOutlook",
                    title: "Current<BR />Outlook",
                    width: "7%",
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "mkt_IndustryRankAndRs",
                    title: "Ind. Group<BR />Rank / RS",
                    width: "7%",
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "fund_EarningsPerShareRating",
                    title: "EPS<BR />Rating",
                    width: "7%",
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "fund_EarningsStability",
                    title: "Earnings<BR />Stability",
                    width: "7%",
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "fund_ReturnOnEquity",
                    title: "Return<BR />On Equity",
                    width: "7%",
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:n0}%',
                },
                {
                    field: "tech_RelativeStrengthRating",
                    title: "RS<BR />Rating",
                    width: "7%",
                    sortable: true,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "tech_AccumDistRating",
                    title: "Acc/Dis<BR />Rating",
                    width: "7%",
                    sortable: false,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "tech_FullCurrentPctK",
                    title: "Full STO<BR />%K",
                    width: "7%",
                    sortable: false,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:n2}',
                },
                {
                    field: "per_ClosingPrice",
                    title: "Closing<BR />Price",
                    width: "7%",
                    sortable: false,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "per_CostPerShare",
                    title: "Cost Per<BR />Share",
                    width: "7%",
                    sortable: false,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "per_SumQtyOwn",
                    title: "Qty<BR />Own",
                    width: "7%",
                    sortable: false,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "action",
                    title: "Action",
                    width: "25%",
                    sortable: false,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: left; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: "analysis",
                    title: "Analysis",
                    width: "25%",
                    sortable: false,
                    headerAttributes: { "class": "table-header-cell", style: "text-align: left; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                }
            ]
        });

        ValueSwapHelper.showHideFields(this.GRID,
            this.MKT_FIELDS, this.NON_MKT_FIELDS);
    }

    private openDetail(e: any) {
        const urlSuffix = GlobalData.URL_SUFFIX_PERSONAL_REPORTS_WATCH_LIST_REPORT +
            '/Detail?symbol=' + e.data.symbol;

        const success = (data: any) => {
            if (e.detailCell != null) {
                e.detailCell.html(data);
            }
        };

        const error = (x: any, y: any, z: any) => {
            e.detailCell = null;
        }

        Ajax.invoke(urlSuffix, 'GET', null, success, error);
    }
}
